export default {
  SortRefNo: {
    Title: 'Sắp xếp lại số chứng từ',
    Note: 'Chức năng này sẽ bỏ ghi sổ các chứng từ liên quan, thay thế số chứng từ cũ bằng số chứng từ mới và ghi sổ lại các chứng từ đó. Bạn nên sao lưu dữ liệu trước khi thực hiện chức năng này.',
    RefType: 'Loại chứng từ',
    Prefix: 'Tiền tố',
    Suffixes: 'Hậu tố',
    StartValue: 'Giá trị bắt đầu',
    LengthNumber: 'Độ dài phần số của CT',
    Backup: 'Sao lưu dữ liệu'
  },
};
